import fire from '@store/firebase';
import { CollectionPath } from '@typings/collections.enum';
import { updateImgAndGetURL } from '../storage';
import { IstoreItem } from '@typings/store/storeItem.interface';
import { updateHashtagsAndGetIdList } from '../hashtag/update-hashtag';
import { Ihashtag } from '@typings/common/hashtag.interface';
const firestore = fire.firestore();

interface Props {
  data: IstoreItem;
  docID: string;
  hashtag?: Ihashtag[];
  fileList?: {
    selectedFile: File | null;
    prevImgURL: string | null;
  };
  prevHashtag?: string[];
}

export async function updateStoreItem({
  hashtag,
  fileList,
  data,
  docID,
  prevHashtag,
}: Props) {
  const collectionPath = CollectionPath.STORE;
  const ref = firestore.collection(collectionPath);

  // fileList가 있으면 이미지 업로드, 없으면 data.imgURL 사용
  let imgURL = data.imgURL || '';
  if (fileList) {
    imgURL = await updateImgAndGetURL({
      selectedFile: fileList.selectedFile,
      prevImgURL: fileList.prevImgURL || '',
      collectionPath,
    });
  }

  // hashtag 추가 및 재설정
  const hashtagIdList = await updateHashtagsAndGetIdList({
    hashtagList: hashtag,
    collectionPath: collectionPath,
    prevHashIdList: prevHashtag,
    docId: docID,
  });

  if (!docID) {
    //추가
    const docId = await ref
      .add({ ...data, imgURL, hashtagIdList })
      .then((res) => res.id);


    await ref.doc(docId).set({ id: docId }, { merge: true });

    return docId;
  }

  if (docID) {
    //수정

    await ref
      .doc(docID)
      .set({ ...data, imgURL, hashtagIdList }, { merge: true })
      .catch((err) => alert(err.message));

    return docID;
  }
}
// -----------------------------------------------------------------
//                            커스텀 아이템 만들기
// -----------------------------------------------------------------
export async function saveCustomItem({
  collectionPath,
  photocardID,
  data,
  selectedFile,
}) {
  const ref = firestore.collection(
    `${collectionPath}/${photocardID}/inventory`,
  );
  const imgURL = await updateImgAndGetURL({
    selectedFile,
    prevImgURL: '',
    collectionPath,
  });
  return ref
    .add({ ...data, customImgURL: imgURL, createdAt: new Date() })
    .catch((err) => alert(err.message));
}
